import React from "react";
import './DialogueTree.css';

interface IDialogueTreeProps{
    onClose: ()=>void;
}

export const DialogueTree = ({onClose}: IDialogueTreeProps)=>{
    return (
        <div className="DialogueTree">
            <div className="DialogueTree_form">
                <div className="DialogueTree_header">
                    <div className="DialogueTree_title">
                        Dialogue tree
                    </div>
                    <div className="addSession_icon addSession_close_icon" onClick={onClose}></div>
                </div>
            </div>
        </div>
    )
}